import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';
import * as React from 'react';
import { Checkbox } from '../../../../Checkbox/Checkbox';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

const dontShowModalStorageKey = 'offline-storage-explanation-modal-shown';

export const isModalSetToDoNotShowAgain = () => {
	return localStorage.getItem(dontShowModalStorageKey) === 'true';
};

export const setModalToDoNotShowAgain = (value: boolean) => {
	localStorage.setItem(dontShowModalStorageKey, value ? 'true' : 'false');
};

export const SaveDataExplanationModal = async (): Promise<boolean> => {
	const model = observable({
		value: false,
	});
	if (isModalSetToDoNotShowAgain()) {
		return true;
	}

	try {
		await newConfirmModal('Offline Storage', <SaveDataExplanationModalContent model={model} />);

		return true;
	} catch (e) {
		return false;
	}
};

interface ModalState {
	model: {
		value: boolean;
	};
}
const SaveDataExplanationModalContent = observer(({ model }: ModalState) => {
	return (
		<div className="spaced-message">
			<p>
				Saving check in data for offline use lets you access and edit the check-in status without an internet
				connection.
			</p>
			<p>
				Any changes made offline will need to be manually synced once you&apos;re back online to ensure they’re
				saved and updated across devices.
			</p>
			<Checkbox
				className="offline-storage-explanation-modal__checkbox"
				model={model}
				modelProperty="value"
				label="Do not show this again?"
				onAfterChecked={(e, checked) => {
					console.log(model.value, checked);
					setModalToDoNotShowAgain(checked);
				}}
			/>
		</div>
	);
});

export const ConfirmOverwritePreviousDataModal = async (): Promise<boolean> => {
	try {
		await newConfirmModal(
			'Offline Storage',
			'There is already check-in data saved for offline use. Do you want to overwrite this data?',
		);

		return true;
	} catch (e) {
		return false;
	}
};

export const ReturnToCheckInPageModal = async (): Promise<boolean> => {
	try {
		await newConfirmModal(
			'Offline Check In',
			'Do you want to return to the check-in page to continue offline check in?',
		);

		return true;
	} catch (e) {
		return false;
	}
};
